module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_7016.c4d728e3.png";